export enum ArgumentsLayoutEnum {
  default = 'default',
  embedded = 'embedded',
  divided = 'divided'
}
